export default "__VITE_ASSET__CGjGF0yJ__"